import React, {ChangeEventHandler, useCallback} from 'react';
import {LinkDto} from "./data/types";
import {Input} from "antd";

export type LinkEditorProps = {
    value?: {type: LinkDto["type"], url: LinkDto["url"]};
    onChange?: (value: {type: LinkDto["type"], url: LinkDto["url"]}) => void;
    type: LinkDto["type"];
}

export const LinkEditor: React.FC<LinkEditorProps> = (props) => {
    const {
        value,
        onChange,
        type
    } = props;

    const internalOnChange: ChangeEventHandler<HTMLInputElement> = useCallback((event) => {
        onChange && onChange({
            url: event.target.value,
            type
        });
    }, [type]);

    return (
        <Input key={type} value={value?.url} onChange={internalOnChange} />
    )
}